/** Homestead maintainers with Dev Tools access. */
export const HOMESTEAD_DEVELOPER_USER_REFS = [
  'user:default/andira.putri',
  'user:default/jeremy.harms',
  'user:default/jeremy.jones15',
  'user:default/marc.fogleman',
  'user:default/matthew.baker18',
  'user:default/salome.chitubila',
  'user:test-data/debug', // Debug user for local development
] as const;

export function isHomesteadDeveloper(userEntityRef: string | null | undefined): boolean {
  if (!userEntityRef) {
    return false;
  }
  return (HOMESTEAD_DEVELOPER_USER_REFS as readonly string[]).includes(userEntityRef);
}
